var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BE52E495-3B69-4553-BFFA-02CA52A7808B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teams/Newteam/Scorecard/velocity",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scorecard2",
    transform: "translate(-447.000000, -363.000000)",
    fill: "#5D6E81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(55.000000, 341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(392.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.69822171,6.15384611 C7.61755834,6.15358055 8.45858944,6.64457806 8.8722909,7.423077 L9.64294975,8.88461548 C9.7694751,9.12270644 9.75696285,9.40594461 9.60988194,9.63316767 C9.46280102,9.86039074 9.20212738,9.99919328 8.92096409,10.0000001 L0.808765642,10.0000001 C0.527602353,9.99919328 0.266928712,9.86039074 0.119847794,9.63316767 C-0.0272331235,9.40594461 -0.0397453664,9.12270644 0.0867799804,8.88461548 L0.897999825,7.423077 C1.30504679,6.65681234 2.12680993,6.16794284 3.03150802,6.15384611 L6.69822171,6.15384611 Z M4.86486486,0 C6.20893791,0 7.2985244,1.03318905 7.2985244,2.30769233 C7.2985244,3.58219562 6.20893791,4.61538467 4.86486486,4.61538467 C3.52079182,4.61538467 2.43120533,3.58219562 2.43120533,2.30769233 C2.43120533,1.03318905 3.52079182,0 4.86486486,0 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSvg);
export default __webpack_public_path__ + "static/media/User_svg.fb7c7612d97d5e63b32a410c81e44481.svg";
export { ForwardRef as ReactComponent };